<div class="form-group">
    <mat-form-field class="full-width">
        <mat-label>{{field.templateOptions.label}}</mat-label>
        <input matInput type="time" [formControl]="formControl" [formlyAttributes]="field">
    </mat-form-field>
</div>
